export default class BannerTakeover {
    constructor(tagName, adObj, ctx) {
        this._tagName = tagName;
        this._adObj = adObj;
        this._container = this.getBannerContainer();
        this._styledVisible = false;

        if (ctx) {
            this._appNexusData = ctx.appNexusData;
            this._allowedTakeoverTags = ctx.allowedTakeoverTags;
            this._sitesettings = ctx.sitesettings;
            this._trackingservice = ctx.trackingservice;
        }
    }
    getElementByAdPosition(pos) {
        return document.getElementById(pos);
    }

    getBannerObj() {
        return this._adObj;
    }

    getBannerContainer() {
        const ele = this.getElementByAdPosition(this._tagName);
        return ele ? ele.parentNode : null;
    }

    getBannerSuperDiv() {
        const superContainer = document.getElementById(`${this._tagName}_container`);
        return superContainer ? superContainer.parentNode : null;
    }

    isInViewport(extraOffset) {
        const elem = this.getBannerSuperDiv();
        if (elem == null) {
            return false;
        }
        const width = elem.offsetWidth;
        const height = elem.offsetHeight;
        const boxTop = elem.offsetTop - extraOffset;
        const boxLeft = elem.offsetLeft - extraOffset;
        const boxBottom = elem.offsetTop + height + extraOffset;
        const boxRight = elem.offsetLeft + width + extraOffset;

        const consumedPageLength = window.pageYOffset + window.innerHeight;
        const consumedPageWidth = window.pageXOffset + window.innerWidth;

        return (
            boxTop < consumedPageLength && boxLeft < consumedPageWidth && boxBottom > window.pageYOffset && boxRight > window.pageXOffset
        );
    }

    isStyledVisible() {
        return this._styledVisible;
    }

    _styleAsTakeover() {
        this._container.classList.add('ad-takeover');
        const topDiv = this.getBannerSuperDiv();
        if (topDiv) {
            topDiv.classList.add('ad-takeover-topDiv');
            topDiv.style.setProperty('z-index', '0', 'important');
        }
    }

    _toggleOn() {
        this._container.classList.add('in-screen');
        this._styledVisible = true;
    }

    _toggleOff() {
        this._container.classList.remove('in-screen');
        this._styledVisible = false;
    }

    toggleInScreenClass() {
        const lookAheadOffset = 200; // #px for triggering in-screen toggle
        const isInView = this.isInViewport(lookAheadOffset);
        const isVisible = this.isStyledVisible();

        if (!isVisible && isInView) {
            this._toggleOn();
        } else if (isVisible && !isInView) {
            this._toggleOff();
        }
    }

    _setToViewportHeight() {
        let vH = window.innerHeight || 0;
        vH -= 100;

        document.querySelectorAll('.ad-takeover').forEach(ele => ele.style.setProperty('height', `${vH}px`, 'important'));
    }

    _listenToOrientationChange() {
        let orientationTimer;
        const UPDATE_TIMEOUT = 150;

        window.addEventListener('orientationchange', () => {
            // viewport height value is not updated immediately by the browser
            // need to delay resizing by 150-200ms
            clearInterval(orientationTimer);
            orientationTimer = setTimeout(() => {
                this._setToViewportHeight();
            }, UPDATE_TIMEOUT);
        });
    }

    _observeTakeoverAd(ad) {
        let scrollTimer;
        const SCROLL_TIMEOUT = 30;

        window.addEventListener('scroll', () => {
            clearInterval(scrollTimer);
            ad.toggleInScreenClass();
            scrollTimer = setTimeout(() => {}, SCROLL_TIMEOUT);
        });
    }

    render() {
        if (this._adObj != null) {
            this._styleAsTakeover();
            // this._toggleOn();
            this._setToViewportHeight();
            this._listenToOrientationChange();
            this._observeTakeoverAd(this);
        }
    }
}
